import { render, staticRenderFns } from "./suspend-user.vue?vue&type=template&id=569784d8"
import script from "./suspend-user.vue?vue&type=script&lang=js"
export * from "./suspend-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports